console.log('ajaxify run');
/*============================================================================
  (c) Copyright 2014 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  Plugin Documentation - https://shopify.github.io/Timber/#ajax-cart

  IMPORTANT NOTE:
    - This is a stripped down version of the ajax cart plugin, specific for this theme.
    - For full documentation, visit https://shopify.github.io/Timber/#ajax-cart

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajaxify plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template) ##not needed
    - modernizer.min.js 
    - snippet/ajax-cart-template.liquid ## not needed

  JQUERY API (c) Copyright 2009-2014 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  Includes slight modifications to addItemFromForm.
  
==============================================================================*/

if ((typeof Shopify) === 'undefined') {
  Shopify = {};
}

Shopify.money_format = '$';


/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
	try {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
  } catch (errf) {console.log("Error: "+errf.message);}
}


/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ( !Shopify.formatMoney ) {
  Shopify.formatMoney = function(cents, format) {
    
    if (format === null) {format = false;} 
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format || Shopify.money_format);
    formatString = formatString.replace("", ""); //Backup case if format is wrong
    if (formatString.length <= 1) {
    	formatString = '$';
    }
    console.log("formatString: "+formatString+" length: "+formatString.length);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
    	try {
      return (typeof opt == 'undefined' ? def : opt);
      } catch (errf) {console.log("Error: "+errf.message);}
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
    	try {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
      } catch (errf) {console.log("Error: "+errf.message);}
    }
    
	var placeholdervar = '';
	try {
		var placeholderarr = formatString.match(placeholderRegex);
		if (typeof placeholderarr[1] !== 'undefined') {
			placeholdervar = placeholderarr[1];
		}
	}
	catch (pherr) {
		try {
    		if (formatString.length <= 1) {
    			placeholdervar = "amount";
    		}
        }
    	catch (pherr2) {
    		console.log(pherr.message+' from: '+formatString);
    	}
	}

    switch(placeholdervar) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        //console.log('placeholdervar empty from: '+formatString);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

Shopify.onProduct = function(product) {
	try {
  //alert('Received everything we ever wanted to know about ' + product.title);
  } catch (errf) {console.log("Error: "+errf.message);}
};

Shopify.onCartUpdate = function(cart) {
	try {
  //alert('There are now ' + cart.item_count + ' items in the cart.');
  } catch (errf) {console.log("Error: "+errf.message);}
};

Shopify.updateCartNote = function(note, callback) {
	try {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
  } catch (errf) {console.log("Error: "+errf.message);}
};



Shopify.onError = function(XMLHttpRequest, textStatus) {
	try {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    console.log(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    console.log('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
  } catch (errf) {console.log("Error: "+errf.message);}
};
var onBundleSuccessCallback = function() {
	try {
		$('body').trigger('refreshDrawer');
	} catch (errf) {
		//console.log("Error: "+errf.message);
	}
};
var onBundleErrorCallback = function() {
	try {
	//console.log('');
	} catch (errf) {console.log("Error: "+errf.message);}
};


/*============================================================================
  POST to cart/add.js returns the JSON of the line item associated with the added item.
==============================================================================*/
Shopify.addItem = function(variant_id, quantity, callback) {
	try {
	quantity = quantity || 1;
	var params = {
		type: 'POST',
		url: '/cart/add.js',
		data: 'quantity=' + quantity + '&id=' + variant_id,
		dataType: 'json',
		success: function(line_item) {
			if ((typeof callback) === 'function') {
				callback(line_item);
			}
			else {
				Shopify.onItemAdded(line_item);
			}
		},
		error: function(XMLHttpRequest, textStatus) {
			Shopify.onError(XMLHttpRequest, textStatus);
		}
	};
	jQuery.ajax(params);
	} catch (errf) {console.log("Error: "+errf.message);}
};

/*============================================================================
  Other Helper Functions
==============================================================================*/

	function miniCartAdjustments() {
      
      
                 
      
      	var headerHeight = 0;
		if (jQuery('.minicart-open').length){
          	//alert('window.headerHeight ='+ window.headerHeight);
            if($('.headwrapper').length){
                headerHeight = parseInt($('.headwrapper').height(),10);
            }
		}
      	jQuery('#main_container').css('top',headerHeight+'px');
    }
    function show_hide_fasttrack(){
      	console.log('show_hide_fasttrack');
      	if(jQuery('#shoppinglist__fasttrack').length){
            var fasttrackprice = 30;
            var fcartprice = $('.items-subtotals-price').html().trim();
          	fcartprice = fcartprice.replace(/(&#[0-9]+;)/g,"").replace(/([^0-9\.]+)/g,"");
            console.log('cartprice = '+fcartprice);
          	if(fcartprice >= 500){
            	fasttrackprice = 90;
              	console.log('show_hide_fasttrack 1 | '+fasttrackprice);
            }
          	else if(fcartprice >= 200){
            	fasttrackprice = 60;
              	console.log('show_hide_fasttrack 2');
          	}
          	else if (fcartprice < 200){
            	fasttrackprice = 30;
              	console.log('show_hide_fasttrack 3');
          	}
          	$('.fasttrack_displayprice').html(fasttrackprice);
        }
        
        if (jQuery('#shoppinglist__fasttrack').length){
                jQuery('.fast-track-row').hide();
        }
        else{
        	jQuery('.fast-track-row').show('300');
        }
    }

/*============================================================================
  POST to cart/add.js returns the JSON of the line item.
    - Allow use of form element instead of id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
	try {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery(form).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        }
        else {
          Shopify.onItemAdded(line_item, form);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        }
        else {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      }
    };
    jQuery.ajax(params);
    } catch (errf) {console.log("Error: "+errf.message);}
};

/*============================================================================
  GET cart.js returns the cart in JSON.
==============================================================================*/
Shopify.getCart = function(callback) {
	try {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      Shopify.onCartUpdate(cart);
    }
  });
  } catch (errf) {console.log("Error: "+errf.message);}
};

/*============================================================================
  GET products/<product-handle>.js returns the product in JSON.
==============================================================================*/
Shopify.getProduct = function(handle, callback) {
	try {
  jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
    if ((typeof callback) === 'function') {
      callback(product);
    }
    else {
      Shopify.onProduct(product);
    }
  });
  } catch (errf) {console.log("Error: "+errf.message);}
};

/*============================================================================
  POST to cart/change.js returns the cart in JSON.
==============================================================================*/
Shopify.changeItem = function(line, quantity, callback) {
	try {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity='+quantity+'&line='+line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
  } catch (errf) {console.log("Error: "+errf.message);}
};


/* Modernizr 2.7.0 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-csstransforms-csstransforms3d-touch-teststyles-testprop-testallprops-prefixes-domprefixes
 */
window.Modernizr=function(a,b,c){function y(a){i.cssText=a}function z(a,b){return y(l.join(a+";")+(b||""))}function A(a,b){return typeof a===b}function B(a,b){return!!~(""+a).indexOf(b)}function C(a,b){for(var d in a){var e=a[d];if(!B(e,"-")&&i[e]!==c)return b=="pfx"?e:!0}return!1}function D(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:A(f,"function")?f.bind(d||b):f}return!1}function E(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+n.join(d+" ")+d).split(" ");return A(b,"string")||A(b,"undefined")?C(e,b):(e=(a+" "+o.join(d+" ")+d).split(" "),D(e,b,c))}var d="2.7.0",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j,k={}.toString,l=" -webkit- -moz- -o- -ms- ".split(" "),m="Webkit Moz O ms",n=m.split(" "),o=m.toLowerCase().split(" "),p={},q={},r={},s=[],t=s.slice,u,v=function(a,c,d,e){var h,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:g+(d+1),l.appendChild(j);return h=["&#173;",'<style id="s',g,'">',a,"</style>"].join(""),l.id=g,(m?l:n).innerHTML+=h,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=f.style.overflow,f.style.overflow="hidden",f.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),f.style.overflow=k),!!i},w={}.hasOwnProperty,x;!A(w,"undefined")&&!A(w.call,"undefined")?x=function(a,b){return w.call(a,b)}:x=function(a,b){return b in a&&A(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=t.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(t.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(t.call(arguments)))};return e}),p.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:v(["@media (",l.join("touch-enabled),("),g,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},p.csstransforms=function(){return!!E("transform")},p.csstransforms3d=function(){var a=!!E("perspective");return a&&"webkitPerspective"in f.style&&v("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a};for(var F in p)x(p,F)&&(u=F.toLowerCase(),e[u]=p[F](),s.push((e[u]?"":"no-")+u));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)x(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof enableClasses!="undefined"&&enableClasses&&(f.className+=" "+(b?"":"no-")+a),e[a]=b}return e},y(""),h=j=null,e._version=d,e._prefixes=l,e._domPrefixes=o,e._cssomPrefixes=n,e.testProp=function(a){return C([a])},e.testAllProps=E,e.testStyles=v,e}(this,this.document);


/*============================================================================
  Ajaxify Shopify Add To Cart
==============================================================================*/

var ajaxifyShopify = (function(module, $) {

  'use strict';

  // Public functions
  var init, refreshCallback;

  // Private general variables
  var settings, cartInit, $drawerHeight, $cssTransforms, $cssTransforms3d, $isTouch;

  // Private plugin variables
  var $refreshDrawer, $formContainer, $btnClass, $wrapperClass, $addToCart, $cartCountSelector, $cartCostSelector, $toggleCartButton, $cartContainer, $closeCart, $drawerContainer;

  // Private functions
  var refreshDrawer, setCustomDrawRefreshEvent, refreshDrawer, updateCountPrice, drawerSetup, showDrawer, hideDrawer, setToggleButtons, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, refreshCart, adjustCart, adjustCartCallback, scrollTop, isEmpty, log;

  /**
   * Initialise the plugin and define global options
   */
  init = function (options) {

    // Default settings
    settings = {
      debug: false,
      method: 'drawer',
      formSelector: 'form[action="/cart/add"]',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      toggleCartButton: null,
      refreshDrawer: null,
      btnClass: null,
      wrapperClass: null
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $btnClass          = settings.btnClass;
    $wrapperClass      = settings.wrapperClass;
    $addToCart         = $(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $toggleCartButton  = $(settings.toggleCartButton);
	 $refreshDrawer  = $(settings.refreshDrawer);

    // CSS Checks
    $cssTransforms   = Modernizr.csstransforms;
    $cssTransforms3d = Modernizr.csstransforms3d;
    $isTouch         = Modernizr.touch;

    // Touch check
    if ($isTouch) {
      $('body').addClass('ajaxify-touch is-touch');
    }

    try {
    drawerSetup();
    } catch (errd) {console.log("Error: "+errd.message);}

    try {
     // alert(settings.addToCartSelector + ' | ' +$addToCart.length);
    if ( $addToCart.length ) {
     // alert('$addToCart');
      // Take over the add to cart form submit
      formOverride();
    }
    } catch (erra) {console.log("Error: "+erra.message);}

    try {
    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    } catch (errj) {console.log("Error: "+errj.message);}
    
  };

  updateCountPrice = function (cart) {
  	try {
      if ($cartCountSelector) {
        $cartCountSelector.html(cart.item_count);
      }
      if ($cartCostSelector) {

        //var price = Shopify.formatMoney(cart.total_price);
          //$cartCostSelector.html(price);
      }
      
    } catch (errf) {console.log("Error: "+errf.message);}
  };
  
	$('body').bind('custom-event', function(e){
	  var $element = e.target;
	});
	
  setCustomDrawRefreshEvent = function () {
  		try {
		if(settings.toggleCartButton){
			// set listener for custom event
			$('body').on('refreshDrawer', function(e, eventInfo) { 
				refreshDrawer(true);
			});
		}
		} catch (errf) {console.log("Error: "+errf.message);}
  };

  setToggleButtons = function () {
  	try {

    // Reselect the element in case it just loaded
    $toggleCartButton  = $(settings.toggleCartButton);

    if ($toggleCartButton) {

      // Turn it off by default, in case it's initialized twice
      $toggleCartButton.off('click');

      $toggleCartButton.on('click', function(e) {
       
        
        e.preventDefault();

        if ( $drawerContainer.hasClass('shoppingbagshow') ) {
         
          hideDrawer();
        } else {
          
          showDrawer(true);
        }

      });

    }
    } catch (errf) {console.log("Error: "+errf.message);}
  };

  drawerSetup = function () {
  	try {
    /* This function is completely changed from the original.
     *
     */

    // Drawer selectors
    $drawerContainer = $('#shoppingBag');
    $cartContainer   = $('.shoppingbag__listcontain');

    setToggleButtons();
    setCustomDrawRefreshEvent();
    } catch (errf) {console.log("Error: "+errf.message);}
  };

  showDrawer = function (toggle) {
  	try {
	 console.log('showDrawer');

      if($('#your-shopping-cart').length){
        
      }
      else{
			$('.mini-cart').addClass('is-visible');
          	$('html').addClass('minicart-open');
      }
      
    // opening the drawer for the first time
    if ( !cartInit && toggle) {
      console.log('showDrawer getCart');
      Shopify.getCart(cartUpdateCallback);
    }

    // Show the drawer
    //alert('Show the drawer');
    miniCartAdjustments();
    show_hide_fasttrack();
    $drawerContainer.addClass('shoppingbagshow');

    scrollTop();
    } catch (errf) {console.log("Error: "+errf.message);}
  };
  
  refreshDrawer = function (toggle) {
  	try {
		console.log('refreshDrawer');
    // refresh the drawer only
    if (toggle) {
    console.log('refreshDrawer getCart');
      Shopify.getCart(cartUpdateCallback);
    }
	} catch (errf) {console.log("Error: "+errf.message);}
  };

  hideDrawer = function () {
  	try {
     miniCartAdjustments();
        	$('.mini-cart').removeClass('is-visible');
          	$('html').removeClass('minicart-open');
      		$('#main_container').css('top','0px');
     $drawerContainer.removeAttr('style').removeClass('shoppingbagshow');

    scrollTop();
    } catch (errf) {console.log("Error: "+errf.message);}
  };
	// edited 10/09/16 NL
  formOverride = function () {
  	try {
	$addToCart.each(function(){
	var $formContainer = $('#'+$(this).attr('form'));
		$formContainer.submit(function(e) {
      e.preventDefault();
      // Remove any previous quantity errors
      $('.qty-error').remove();
      Shopify.addItemFromForm(e.target, itemAddedCallback, itemErrorCallback);
    });
	});
	} catch (errf) {console.log("Error: "+errf.message);}
  };

  itemAddedCallback = function (product) {
  	try {
    Shopify.getCart(cartUpdateCallback);
    } catch (errf) {console.log("Error: "+errf.message);}
  };
  
  refreshCallback = function () {
  	try {
    itemAddedCallback();
    } catch (errf) {console.log("Error: "+errf.message);}
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
  	try {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.append('<p class="qty-error">'+ data.description +'</p>')
      }
    }
    } catch (errf) {console.log("Error: "+errf.message);}
  };

  cartUpdateCallback = function (cart) {
  	try {
    // Update quantity and price
    updateCountPrice(cart);
	console.log('cartUpdateCallback-1');
    refreshCart(cart);
    console.log('cartUpdateCallback-2');
    showDrawer();
    console.log('cartUpdateCallback-3');
    } catch (errf) {console.log("Error: "+errf.message);}
  };
  
  function cartStuff() {
  	try {
    	$(document).ready(function(){
			try {
              	if ($('#attributeagent').length) {
                    $('#attributeagent').val(navigator.userAgent);
                    $('#attributeos').val(navigator.platform);
                    console.log("userAgent "+navigator.userAgent);
                    console.log("platform "+navigator.platform);
                }
                else {
                  console.log("#attributeagent (ready) not found");
                }
			} catch (cartattributeerr2) {console.log("cartattributeerr2 "+cartattributeerr2.message);}
    	});
    	try {
                if ($('#attributeagent').length) {
                    $('#attributeagent').val(navigator.userAgent);
                    $('#attributeos').val(navigator.platform);
                    console.log("userAgent "+navigator.userAgent);
                    console.log("platform "+navigator.platform);
                }
                else {
                  console.log("#attributeagent not found");
                }
    	} catch (cartattributeerr3) {console.log("cartattributeerr3 "+cartattributeerr3.message);}
    } catch (errf) {console.log("Error: "+errf.message);}
  }

  refreshCart = function (cart) {
  	try {
    var url = '/cart?' + Date.now() + ' #shoppingBagInner';
    $drawerContainer.load(url, function() {
		console.log('refreshCart()');
      // Tell our plugin that the cart has loaded
      cartInit = true;

      // With new elements we need to relink the adjust cart functions
      adjustCart();
      cartStuff();
      
      //Re-initialise cart for alternative checkout buttons
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        console.log("StorefrontExpressButtons.initialize()");
        Shopify.StorefrontExpressButtons.initialize();
      }
      else {
        console.log("NO StorefrontExpressButtons.initialize()");
      }
      
    });
    } catch (errf) {console.log("Error: "+errf.message);}
    
  };

  adjustCart = function () {

    // This function only runs if the entire cart is reprinted.
    // To be safe, turn off the previous clicks that were assigned.
    var qtyAdjust = $('.qty__sub, .qty__add, .qty__delete'),
        qtyNew = 0,
        qtyInput = $('.qty__num');

    // Add or remove from the quantity
    qtyAdjust.off('click');
    qtyAdjust.on('click', function() {
    	try {
      var el = $(this),
          line = el.data('line'),
          qtySelector = el.parents('.shoppinglist__product').find('.qty__num'),
          qtyCurrent = parseInt( qtySelector.val() );

      // Add or subtract from the current quantity
      if (el.hasClass('qty__add')) {
        qtyNew = qtyCurrent + 1;
      } else if (el.hasClass('qty__delete')) {
      	qtyNew = 0;
      } else {
        qtyNew = qtyCurrent - 1;
        if (qtyNew < 0) qtyNew = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qtyNew);
      } else {
        qtySelector.val(qtyNew);
      }
      } catch (err1) {console.log("Error: "+err1.message);}
    });

    // Update quantity based on input on change
    qtyInput.off('change');
    qtyInput.on('change', function() {
    	try {
      var el = $(this),
          line = el.data('line'),
          qty = el.val();

      if (line) {
        updateQuantity(line, qty);
      }
      } catch (err2) {console.log("Error: "+err2.message);}
    });

    // Highlight the text when focused
    qtyInput.off('focus');
    qtyInput.on('focus', function() {
    	try {
      var el = $(this);
      setTimeout(function() {
        el.select();
      }, 50);
      } catch (err3) {console.log("Error: "+err3.message);}
    });

    function updateQuantity(line, qty) {
    	try {
      var row = $('.shoppinglist__product[data-line="' + line + '"]').addClass('is-loading');

      if ( qty == 0 ) {
        row.addClass('is-removed').slideUp();
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        Shopify.changeItem(line, qty, adjustCartCallback);
      }, 250);
      } catch (err4) {console.log("Error: "+err4.message);}
    }

    // Save note anytime it's changed
    var noteArea = $('textarea[name="note"]');
    noteArea.off('change');
    noteArea.on('change', function() {
    	try {
      var newNote = $(this).val();

      // Simply updating the cart note in case they don't click update/checkout
      Shopify.updateCartNote(newNote, function(cart) {});
      } catch (err5) {console.log("Error: "+err5.message);}
    });

    // Reset toggle buttons
    setToggleButtons();
    if (typeof GoogleWalletButton === "function") GoogleWalletButton();
    if (typeof AmazonPaymentsPayButton === "function") AmazonPaymentsPayButton();
    
    //check if fast track is in cart
	show_hide_fasttrack();
  };

  adjustCartCallback = function (cart) {
  	try {
    // Update quantity and price
    updateCountPrice(cart);
      

    // Hide the drawer if we're at 0 items
    if ( cart.item_count == 0 ) {
      hideDrawer();
    }

    // Reprint cart
    Shopify.getCart(refreshCart);
      
      //Re-initialise cart for alternative checkout buttons
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        console.log("StorefrontExpressButtons.initialize() 2");
        Shopify.StorefrontExpressButtons.initialize();
      }
      else {
        console.log("NO StorefrontExpressButtons.initialize() 2");
      }  
      
    } catch (errf) {console.log("Error: "+errf.message);}
  };

  scrollTop = function () {
  	try {
    if ($('body').scrollTop() > 0) {
      $('html, body').animate({
        scrollTop: 0
      }, 250, 'swing');
    }
    } catch (errf) {console.log("Error: "+errf.message);}
  };

  isEmpty = function(el) {
  	try {
    return !$.trim(el.html());
    } catch (errf) {console.log("Error: "+errf.message);}
  };

  log = function (arg) {
  	try {
    if (settings && settings.debug && window.console) {
      try {
        console.log(arg);
      }
      catch (e) {}
    }
    } catch (errf) {console.log("Error: "+errf.message);}
  };

  module = {
    init: init
  };

  return module;

}(ajaxifyShopify || {}, jQuery));
